<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter">
<figure class="figure">
<p class="fig"><img alt="" height="600" src="images/Chi-rapp-fig02001.jpeg" width="395"/></p>
<p class="figh"><a class="page" id="p20"></a>John J. Evers Jr., circa 1903. (New York Public Library.)</p>
</figure>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-rapp-0013.vue?09cc48a3